import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";
import { IdentityParameter } from "@/features/types";
import useSWR, { SWRConfiguration } from "swr";
import { UrlParser } from "@/features/ui/helpers/url-parser";
import { StringTransformer } from "@/features/ui/helpers/string-transformer";
import { OrderSheetRevision } from "@/features/order-sheet-sets/order-sheet-revision.type";
import {
  PageNumberBasedListRequest,
  PageNumberBasedListResponse,
} from "@/features/types";
import useListOrderSheetRevisionsV2Fetcher from "./use-list-order-sheet-revisions-fetcher-v2";
import { AxiosRequestConfig } from "axios";

export const DEFAULT_LIST_REVISIONS_PAGE_SIZE = 10;

export interface ListOrderSheetRevisionsV2Request
  extends PageNumberBasedListRequest {
  submitted__eq?: boolean;
}

export interface ListOrderSheetRevisionsV2Response
  extends PageNumberBasedListResponse {
  revisions: OrderSheetRevision[];
}

export interface ListOrderSheetRevisionsV2PathParameter
  extends IdentityParameter {
  orderSheetSetId: number;
}

export const getListOrderSheetRevisionsV2TemplateUrl =
  "/:by/:companyId/order-sheet-sets/:orderSheetSetId/revisions";

export function parseListOrderSheetRevisionsV2Key(
  key: AxiosRequestConfig<ListOrderSheetRevisionsV2Request>
) {
  const urlParser = new UrlParser<ListOrderSheetRevisionsV2PathParameter>(
    getListOrderSheetRevisionsV2TemplateUrl,
    {
      by: StringTransformer.parseBy,
      companyId: StringTransformer.parseId,
      orderSheetSetId: StringTransformer.parseId,
    }
  );
  return {
    parameter: urlParser.parse(key.url!),
    request: key.params!!,
  };
}

export function getListOrderSheetRevisionsV2Key(
  parameter: ListOrderSheetRevisionsV2PathParameter,
  request?: ListOrderSheetRevisionsV2Request
): AxiosRequestConfig<ListOrderSheetRevisionsV2Request> {
  return {
    url: calcUrl(getListOrderSheetRevisionsV2TemplateUrl, parameter),
    params: request,
  };
}

export default function useListOrderSheetRevisionsV2(
  parameter: ListOrderSheetRevisionsV2PathParameter,
  request?: ListOrderSheetRevisionsV2Request,
  config?: SWRConfiguration
) {
  const fetcher = useListOrderSheetRevisionsV2Fetcher();

  return useSWR(
    getListOrderSheetRevisionsV2Key(parameter, request),
    fetcher,
    config
  );
}
